const getSkusOfProductShipment = (skus, limit = 2) => {
    const skuList = []
    skus?.forEach((sku, index) => {
        if (index < limit) {
            skuList.push({
                header: sku.header,
                imageUrl: sku.image,
                skuId: sku.sku_id,
                subHeader: sku.sub_header,
            })
        }
    })

    return skuList
}
const getHiddenSkusOfProductShipment = (skus, limit = 2) => {
    const hiddenSkuList = []
    skus?.forEach((sku, index) => {
        if (index >= limit) {
            hiddenSkuList.push({
                header: sku.header,
                imageUrl: sku.image,
                skuId: sku.sku_id,
                subHeader: sku.sub_header,
            })
        }
    })

    return hiddenSkuList
}
export const parsingListOfTestItems = (data, limit = 3) => {
    const count = limit || data?.length
    let listOfTest = []
    data?.forEach((item, index) => {
        if (index < count) {
            listOfTest.push({
                id: item.sku_id,
                skuCategory: item.cart_category || "",
                image: {
                    imageUrl: item.image?.url,
                    altText: item.image?.alt,
                },
                header: item.header,
                productType: null,
                discountPercent: item.prices?.discount,
                discountedPrice: item.prices?.discounted_price,
                price: item.prices?.mrp || "",
                description: item?.info,
                icon: {
                    iconUrl: item.delete_icon?.url,
                    altText: item.delete_icon?.alt,
                },
                tag: {
                    label: item.tag?.text,
                    borderColor: item.tag?.border_color,
                    color: item?.tag?.text_color,
                    backgroundColor: item.tag?.bg_color,
                },
                priceText: item.final_price || "",
                subText: item?.patient_count,
                url: item?.url,
                isAvailable: item?.is_available,
                informationDetails: item?.patients_data?.display_text,
                patientDetails: {
                    header: item.patients_data?.details?.header,
                    description: item.patients_data?.details?.description,
                    confirmCta: item.patients_data?.details?.confirm_cta?.text,
                },
            })
        }
    })
    return listOfTest
}
const parseHiddenListOfTestItems = (data, limit) => {
    let hiddenListOfTest = []
    data?.forEach((item, index) => {
        if (index >= limit) {
            hiddenListOfTest.push({
                id: item?.sku_id,
                skuCategory: item.cart_category || "",
                image: {
                    imageUrl: item.image?.url,
                    altText: item.image?.alt,
                },
                header: item.header,
                productType: null,
                discountPercent: item.prices?.discount,
                discountedPrice: item.prices?.discounted_price,
                price: item.prices?.mrp || "",
                description: item?.info,
                icon: {
                    iconUrl: item.delete_icon?.url,
                    altText: item.delete_icon?.alt,
                },
                tag: {
                    label: item.tag?.text,
                    borderColor: item.tag?.border_color,
                    color: item?.tag?.text_color,
                    backgroundColor: item.tag?.bg_color,
                },
                priceText: null,
                subText: null,
                url: item?.url,
                isAvailable: item?.is_available,
                informationDetails: item?.patients_data?.display_text,
                patientDetails: {
                    header: item.patients_data?.details?.header,
                    description: item.patients_data?.details?.description,
                    confirmCta: item.patients_data?.details?.confirm_cta?.text,
                },
            })
        }
    })
    return hiddenListOfTest
}
export const parseBottomSheetData = (widgets) => {
    let labDetailsBottomSheetData = {}
    widgets?.length > 0 &&
        widgets.forEach((item) => {
            switch (item?.type) {
                case "basic_details": {
                    labDetailsBottomSheetData.labTestDescriptionProps = {
                        type: item?.type,
                        title: item?.data?.title,
                        image: {
                            url: item?.data?.image?.url,
                            altText: item?.data?.image?.alt,
                        },
                    }
                    break
                }
                case "rating_widget": {
                    labDetailsBottomSheetData.ratingsOverviewProps = {
                        type: item?.type,
                        bookinCountImageUrl: item?.data?.booking_count_image?.url,
                        bookinCountImageAlt: item?.data?.booking_count_image?.alt,
                        bestSellerTag: item?.data?.best_seller?.tag,
                        bestSellerText: item?.data?.best_seller?.display_text,
                        etaImageUrl: item?.data?.eta?.image?.url,
                        etaImageAlt: item?.data?.eta?.image?.alt,
                        etaImageText: item?.data?.eta?.display_text,
                        socialCueIcon: item?.data?.social_cue?.icon,
                        socialCueText: item?.data?.social_cue?.display_text,
                        bookingCount: item?.data?.booking_count,
                        overviewValue: item?.data?.overview?.value,
                        overviewOutOf: item?.data?.overview?.outOf,
                        ratingCount: item?.data?.overview?.rating_count,
                        reviewCount: item?.data?.overview?.review_count,
                        overviewText: item?.data?.overview?.display_text,
                        etaTextData: item?.data?.certificate?.header
                            ? {
                                  text: item?.data?.certificate?.header,
                                  imageUrl: item?.data?.certificate?.image?.url,
                                  imageAltText: item?.data?.certificate?.image?.alt,
                              }
                            : null,
                    }
                    break
                }
                case "general_description": {
                    labDetailsBottomSheetData.generalDescriptionProps = {
                        type: item?.type,
                        header: item?.data?.header,
                        content: item?.data?.display_text,
                    }
                    break
                }
            }
        })
    return labDetailsBottomSheetData
}

export const parseWidgetData = (widgets) => {
    let widgetData = {}
    let productShipmentData = []
    widgets?.forEach((widget) => {
        switch (widget.type) {
            case "address_selection": {
                widgetData["addressSelection"] = parseAddressSelection(widget)
                break
            }
            case "quick_editable_details": {
                widgetData["quickEditableDetails"] = {
                    header: widget.data?.header,
                    subHeading: widget.data?.sub_header,
                    details: widget.data?.details?.map((detail) => ({
                        imageUrl: detail.icon,
                        subText: detail.sub_text,
                        description: detail.display_text,
                        ctaLabel: detail.cta?.text,
                        ctaAction: detail.cta?.action,
                        targetUrl: detail.cta?.target_url,
                        isCtaEnabled: true,
                        errorText: detail.error_message,
                    })),
                    isLoading: false,
                    isTextHidden: false,
                    variantSmall: true,
                }
                break
            }
            case "labs_preparation": {
                widgetData["labsPreparation"] = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    descriptionData: {
                        description: widget.data?.instructions,
                        color: null,
                        backgroundColor: widget.data?.background_color,
                    },
                }
                break
            }
            case "list_tests_cart": {
                const items = widget.data?.items ? widget.data?.items : widget?.data?.grouped_items[0]?.items
                widgetData["listOfTestOnCart"] = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    listOfItems: parsingListOfTestItems(items, widget.data?.up_front_count),
                    hiddenListOfTest: widget.data?.up_front_count
                        ? parseHiddenListOfTestItems(items, widget.data?.up_front_count)
                        : [],
                    linkText: widget.data?.cta?.text,
                    labItems: {
                        labId: widget.data?.lab?.id,
                        url: widget.data?.lab?.url,
                        imageUrl: widget.data?.lab?.image?.url,
                        altText: widget.data?.lab?.image?.alt,
                        header: widget.data?.lab?.header,
                        subHeader: widget.data?.lab?.sub_header,
                        ctaLabel: null,
                        changeLabsUrl: null,
                    },
                    footerData: {
                        label: widget.data?.footer?.label,
                        labIcon: widget.data?.footer?.lab_icon?.url,
                        labAltText: widget.data?.footer?.lab_icon?.alt,
                        infoIconData: {
                            infoIconUrl: widget.data?.footer?.info_icon?.url,
                            infoIconAlt: widget.data?.footer?.info_icon?.alt,
                        },
                    },
                    bottomSheetData: {
                        header: widget.data?.footer?.lab_details_bottomsheet?.heading,
                        ...parseBottomSheetData(widget.data?.footer?.lab_details_bottomsheet?.data),
                    },
                }
                break
            }

            case "footnotes": {
                widgetData["footnotes"] = {
                    subHeader: widget.data.sub_text,
                    data: [
                        {
                            header: "",
                            displayText: widget.data.display_text,
                        },
                    ],
                }
                break
            }
            case "bill_summary": {
                widgetData["billSummaryWidget"] = {
                    header: widget.data.header,
                    priceBreakUp: getParsedPriceBreakups(widget.data.price_breakups),
                    paymentDetails: {
                        label: widget.data.label,
                        value: widget.data.payable_amount,
                    },
                }

                break
            }
            case "care_plan_upsell": {
                widgetData["carePlanUpsell"] = parseCarePlanUpsellData(widget.data)
                break
            }
            case "product_shipment": {
                let data = {
                    header: widget.data.header,
                    subHeader: widget.data.display_text,
                    icon: widget.data.icon,
                    primaryCtaLabel: widget.data.primary_cta?.text,
                    skus: getSkusOfProductShipment(widget.data.skus),
                    ctaLabel: widget.data.skus?.length > 2 ? widget.data.list_expand_text : "",
                    hiddenSkus: getHiddenSkusOfProductShipment(widget.data.skus),
                    targetUrl: widget.data.primary_cta?.target_url,
                    iconDialogData: widget.data.dialog_data,
                }
                productShipmentData.push(data)
                break
            }
            case "no_rx_upsell": {
                widgetData["lowEmphasisUpsell"] = {
                    header: widget.data.header,
                    description: widget.data.display_text,
                    subHeader: widget.data.sub_header,
                    time: widget.data.time,
                    image: widget.data.image_url,
                }
                break
            }
            case "tcp_points_details": {
                widgetData["tcpPoints"] = {
                    header: widget?.data?.redeem?.title,
                    availed: widget?.data?.redeem?.availed,
                    headerIcon: widget?.data?.redeem?.logo,
                    secondaryText: widget?.data?.redeem?.sub_title,
                    checkBoxMessage: widget?.data?.redeem?.redeemable_message,
                    redeemablePoints: widget?.data?.redeem?.balance,
                    earnedInfo: {
                        text: widget?.data?.earn?.earn_message_1,
                        subText: widget?.data?.earn?.earn_message_2,
                    },
                    carePlan: {
                        user: {
                            cpUser: widget?.data?.earn?.care_plan?.cp_user ? true : false,
                            text: widget?.data?.earn?.care_plan?.cp_user
                                ? widget?.data?.earn?.care_plan?.cp_user?.text
                                : widget?.data?.earn?.care_plan?.non_cp_user?.text,
                            icon: widget?.data?.earn?.care_plan?.cp_user
                                ? widget?.data?.earn?.care_plan?.cp_user?.logo
                                : widget?.data?.earn?.care_plan?.non_cp_user?.icon,
                            functionMap: "carePlanInfoDialog",
                            infoIcon: widget?.data?.earn?.care_plan?.cp_user
                                ? null
                                : widget?.data?.earn?.care_plan?.non_cp_user?.help?.icon,
                            targetUrl: widget?.data?.earn?.care_plan?.cp_user
                                ? null
                                : widget?.data?.earn?.care_plan?.non_cp_user?.help?.target,
                        },
                        upsell: {
                            buttonType: "textual",
                            payload: {
                                skus: [
                                    {
                                        quantity:
                                            widget?.data?.earn?.care_plan?.upsell?.cta?.details?.quantity,
                                        sku_id: widget?.data?.earn?.care_plan?.upsell?.cta?.details?.sku_id,
                                    },
                                ],
                                page_source: "order_summary",
                            },
                            label: widget?.data?.earn?.care_plan?.upsell?.cta?.text,
                            responseType: "brief",
                        },
                        statusInfo: {
                            text: widget?.data?.earn?.care_plan?.cp_status_info?.text,
                            icon: widget?.data?.earn?.care_plan?.cp_status_info?.icon,
                        },
                    },
                }
                break
            }
        }
    })

    return { widgetData: widgetData, productShipmentData: productShipmentData }
}
const parseAddressSelection = (widget) => {
    return {
        header: widget.data.header,
        address: `${widget.data.street1 ? widget.data.street1 + ", " : ""}${
            widget.data.street2 ? widget.data.street2 + ", " : ""
        }${
            widget.data.city && widget.data.street1
                ? decodeURI(widget.data.city) + ", "
                : decodeURI(widget.data.city)
        }${widget.data.locality ? widget.data.locality + ", " : ""}${widget.data.state}${
            widget.data.pincode ? " (" + widget.data.pincode + ")" : ""
        }`,
        ctaLabel: widget.data.cta?.text,
        redirectUrl: widget.data.cta?.target_url,
        icon: widget.data.icon,
        geodataUpdateRequired: widget.data.is_geodata_update_required,
        id: widget.data.id,
        name: widget.data.name,
        addressType: widget.data.address_name,
        number: widget.data.contact_number,
    }
}

const getParsedPriceBreakups = (priceBreakups) => {
    const breakUps = []

    priceBreakups?.forEach((priceBreakUp) => {
        const breakUpObj = {
            header: priceBreakUp.display_text,
            originalPrice: priceBreakUp.price?.text,
            subHeader: priceBreakUp.sub_text,
            image: {
                url: priceBreakUp.info?.icon,
                altText: "price breakup",
                functionMap: priceBreakUp.info?.action,
                info: {
                    ...priceBreakUp.info?.data,
                    breakup: getParsedPriceBreakups(priceBreakUp.info?.data?.breakup),
                    header: priceBreakUp.info?.header,
                },
            },
            underlinedText: {
                text: priceBreakUp.underline_text_cta?.label,
                functionMap: priceBreakUp.underline_text_cta?.action,
            },
        }

        breakUps.push(breakUpObj)
    })

    return breakUps
}

export const parseSkuList = (skuList) => {
    let listOfItems = {
        groupItems: [
            {
                itemInCart: skuList.map((item) => {
                    return {
                        imageUrl: item.imageUrl,
                        header: item.header,
                        subHeader: item.subHeader,
                        skuId: item.skuId,
                    }
                }),
            },
        ],
    }
    return listOfItems
}
export const parsePageInfoWidget = (pageInfoData) => {
    let pageInfoWidgets = {}
    if (pageInfoData.action_button) {
        pageInfoWidgets["actionButton"] = {
            targetUrl: pageInfoData.action_button.target_url,
            text: pageInfoData.action_button.cta?.text,
        }
    }
    if (pageInfoData.attached_prescription_data) {
        pageInfoWidgets["attachedPrescription"] = {
            listOfImages: pageInfoData.attached_prescription_data.data?.map((item) => {
                return {
                    image: {
                        url: item.transformed_urls.small,
                        xxhighUrl: item.file_attr?.length ? item.file_attr[0].file_url : "",
                        alt: "prescription",
                        id: item.id,
                        type:
                            item.file_attr[0]?.format?.includes("pdf") ||
                            item.file_attr[0]?.format?.includes("application")
                                ? "pdf"
                                : "image",
                        cta: {
                            functionMap: "prescriptionClicked",
                        },
                        statusText: item.status,
                        documentUrl:
                            item.file_attr[0]?.format?.includes("pdf") ||
                            item.file_attr[0]?.format?.includes("application")
                                ? item.file_attr[0].file_url
                                : item.file_attr[0].file_url ||
                                  item.prescription_icon_url ||
                                  item.transformed_urls.xhigh,
                    },
                }
            }),
            header: pageInfoData.attached_prescription_data?.header,
        }
    }
    if (pageInfoData.care_plan_bottomsheet) {
        const data = pageInfoData.care_plan_bottomsheet
        pageInfoWidgets["carePlanDialogData"] = {
            header: data.header,
            imageUrl: data.icon,
            displayText: data.display_text,
            planDetails:
                data.plan_details && Object.keys(data.plan_details).length > 0
                    ? {
                          header: data.plan_details.header,
                          subHeader: data.plan_details.sub_header,
                          priceDetails: {
                              price: data.plan_details.prices?.mrp,
                              discount: data.plan_details.prices?.discount,
                              discountedPrice: data.plan_details.prices?.discounted_price,
                          },
                          cta: {
                              label: data.plan_details.cta?.text,
                              url: data.plan_details.cta?.details?.target_url,
                              functionMap: "carePlanInfoDialog",
                          },
                      }
                    : {},
            benefits: data.benefits?.map((benefit) => {
                return {
                    icon: benefit.icon,
                    displayText: benefit.display_text,
                }
            }),
            addToCart: {
                label: data.primary_cta?.text,
                payload: {
                    skus: [
                        {
                            quantity: data.primary_cta?.details?.quantity,
                            sku_id: data.primary_cta?.details?.sku_id,
                        },
                    ],
                    page_source: "order_summary",
                },
                responseType: "brief",
            },
            secondaryCta: {
                label: data.secondary_cta?.text,
            },
            skuDetails: {
                quantity: data.primary_cta?.details?.quantity,
                skuId: data.primary_cta?.details?.sku_id,
            },
        }
    }
    return pageInfoWidgets
}
export const changeEtaSelectedItem = (data, deliverySpeedId = null, shipmentId = null) => {
    return {
        header: data.header,
        showCpUpsell: data.showCpUpsell,
        showFootnotes: data.showFootnotes,
        optionId: data.optionId,
        shipments: data.shipments?.map((item) => {
            return {
                skuListLimit: item.skuListLimit,
                shouldShowSku: item.shouldShowSku,
                header: item.header,
                underlineCtaLabel: item.underlineCtaLabel,
                id: item.id,
                skus: item.skus,
                deliverySpeedOptions: item.deliverySpeedOptions?.map((option) => {
                    return {
                        title: option.title,
                        subtitle: option.subtitle,
                        deliveryInfo: option.deliveryInfo,
                        discountedPriceValue: option.discountedPriceValue,
                        id: option.id,
                        isSelected:
                            shipmentId === item.id && option.id === deliverySpeedId
                                ? true
                                : shipmentId !== item.id && shipmentId
                                ? option.isSelected
                                : shipmentId === item.id && option.id !== deliverySpeedId
                                ? false
                                : option.isSelected,

                        price: option.price,
                        discountedPrice: option.discountedPrice,
                        carePlanInfo: option.carePlanInfo,
                        functionMap: option.functionMap,
                    }
                }),
                hiddenSkus: item.hiddenSkus,
            }
        }),
    }
}
export const parseCarePlanUpsellData = (data) => {
    if (data)
        return {
            header: data.header,
            subHeader: data.sub_header,
            imageUrl: data.icon,
            displayText: data.sub_header,
            planDetails:
                data.plan_details && Object.keys(data.plan_details).length > 0
                    ? {
                          header: data.plan_details.header,
                          subHeader: data.plan_details.sub_header,
                          priceDetails: {
                              price: data.plan_details.prices?.mrp,
                              discount: data.plan_details.prices?.discount,
                              discountedPrice: data.plan_details.prices?.discounted_price,
                          },
                          cta: {
                              label: data.plan_details.cta?.text,
                              functionMap: data.plan_details.cta?.action,
                              details: data.plan_details.cta?.details,
                          },
                      }
                    : {},
            addToCart: {
                label: data.primary_cta?.text,
                payload: {
                    skus: [
                        {
                            quantity: data.primary_cta?.details?.quantity,
                            sku_id: data.primary_cta?.details?.sku_id,
                        },
                    ],
                    page_source: "order_summary",
                },
                responseType: "brief",
            },
            secondaryCta: {
                label: data.plan_details?.cta?.text,
                functionMap: data.plan_details?.cta?.action,
                skuId: data.plan_details?.cta?.details?.sku_id,
            },
        }
    else return null
}
